<style>
.v-label {
  font-size: 12px !important;
}
#attachmentsRegisterModal .modal__content {
  height: calc(100% - 60px) !important;
}
</style>

<template>
  <div style="height: 85%">
    <v-layout>
      <v-flex
        xs7
        class="table__wrapper--center"
      >
        <v-layout
          row
          wrap
        >
          <v-icon
            class="table__btn--green"
            @click="addAttachment"
            v-if="selectedRows.length > 0"
            style="margin-top: -3px;margin-right: 5px;"
          >add_circle</v-icon>
          <p
            class="caption"
            @click="addAttachment"
            v-if="selectedRows.length > 0"
          >DODAJ ZAŁĄCZNIKI DO ZAZNACZONYCH OBIEKTÓW</p>
        </v-layout>
        <v-spacer />
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
      :rowSelection="'multiple'"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";

export default {
  name: "App",
  props: {
    isCardAttachment: {
      type: Boolean,
      required: false,
      default: false
    },
    objectIdCard: {
      type: Number,
      required: false
    },
    objectTableCard: {
      type: String,
      required: false
    },
    objectTypeCard: {
      type: String,
      required: false
    }
  },
  data: () => ({
    filter: "",
    numberAll: '0', //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: '0', //hint z textfielda wymaga, by wartość była typu string
    selectedRows: [],
    tableTitle: "attachmentTable"
  }),
  components: {
    AgGridVue
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onSelectionChanged: this.onSelectionChanged,
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        rowData: this.loadData(),
        rowSelection: "single",
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    attachments() {
      return this.$store.getters.getAttachments;
    }
  },
  beforeMount() {
    let dict = [
      {
        headerName: "ID załącznika",
        field: "id",
        checkboxSelection: true
      },
      {
        headerName: "Nazwa",
        field: "abstract"
      },
      {
        headerName: "Nazwa tabeli",
        field: "object_table_verbose"
      },
      {
        headerName: "Tabeli",
        field: "object_table",
        hide: true
      },
      {
        headerName: "Typ załącznika",
        field: "mimetype"
      },
      {
        headerName: "Data dodania",
        field: "posted_at",
        cellRenderer: date => {
          return new Date(date.value).toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
        }
      },
      {
        headerName: "Dodano przez",
        field: "posted_by_name"
      },
      {
        headerName: "ID załącznika",
        field: "object_id",
        hide: true
      }
    ];
    this.columnDefs = [];
    dict.forEach(field => {
      this.columnDefs.push(field);
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    addAttachment() {
      for(let oid of this.selectedRows) {
        let payload = {
          objects: [
            {
              object_id: this.objectIdCard,
              object_table: this.objectTableCard,
              object_type: this.objectTypeCard,
            }
          ]
        }
        this.$store
          .dispatch("addAttachmentToObject", [oid.id, payload])
          .then(r => {
            if(r.status != 200) {
              this.$root.$emit(
                "showSnackbar",
                "red",
                `${r.data.message}`
              );
              return;
            } else {
              this.$root.$emit(
                "showSnackbar",
                "success",
                "Pomyślnie dodano załącznik do zaznaczonych obiektów"
              );
              this.$emit("attachmentAdded");
            }
          });
      }
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      const self = this;
      this.$store.dispatch("getAttachments").then(success => {
        if(success) {
          self.numberAll = self.attachments.data.length;
          self.numberFiltered = self.numberAll;
          self.gridOptions.api.setRowData(self.attachments.data);
        }
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRows = this.gridOptions.api.getSelectedRows();
    },
    refreshGrid() {
      const self = this;
      this.$store.dispatch("getAttachments").then(() => {
        if(this.gridOptions.api) {
          self.gridOptions.api.setRowData(self.$store.getters.getAttachments.data);
          self.numberAll = self.gridOptions.api.getModel().rowsToDisplay.length;
          self.numberFiltered = self.numberAll;
        }
      });
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  mounted() {
    this.$root.$on("addedAttachmentsGlobal", this.refreshGrid);
    this.$root.$on("deletedAttachmentGlobal", this.refreshGrid);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/attachments/DatabaseAttachments.vue